<template>
<v-snackbar
  v-if="snackbar"
  :value="snackbar"
  @input="reset"
  top
  :timeout="6000"
>
  {{ message }}
  <template v-slot:action="{ attrs }">
    <v-btn
      v-bind="attrs"
      :color="color"
      text
      @click="reset()"
    >
      Schließen
    </v-btn>
  </template>
</v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  computed: {
    snackbar() {
      return this.$store.state.userMessage !== null;
    },
    color() {
      return this.$store.state.userMessage.type;
    },
    message() {
      return this.$store.state.userMessage.msg;
    }
  },
  methods: {
    reset() {
      this.$store.dispatch("userMessage", null);
    }
  },
};
</script>
